import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Translate } from '../../../../../shared/LanguageService';

type AddressOverwriteDialogProps = {
    isOpen: boolean;
    onOverwrite: () => void;
    onKeepAddress: () => void;
};

export function AddressOverwriteDialog({
    isOpen,
    onOverwrite,
    onKeepAddress
}: AddressOverwriteDialogProps) {
    return (
        <Dialog open={isOpen} onClose={onKeepAddress} aria-labelledby="address-overwrite-title">
            <DialogTitle id="address-overwrite-title">
                {Translate('order/create/v2/location/overwrite/title')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ fontSize: '14px' }}>
                    {Translate('order/create/v2/location/overwrite/text')}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ padding: '16px' }}>
                <Button variant="outlined" onClick={onKeepAddress}>
                    {Translate('order/create/v2/location/overwrite/cancel')}
                </Button>
                <Button variant="contained" onClick={onOverwrite}>
                    {Translate('order/create/v2/location/overwrite/confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
